/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon20Solid = forwardRef('ArrowDUturnLeftUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M.434 6.957a1.25 1.25 0 0 0 1.933 1.585L4.25 6.246V11a7.25 7.25 0 0 0 14.5 0V6.5a1.25 1.25 0 1 0-2.5 0V11a4.75 4.75 0 0 1-9.5 0V6.246l1.883 2.296a1.25 1.25 0 1 0 1.934-1.585L7.433 3.136a2.5 2.5 0 0 0-3.866 0L.434 6.957Z" })));
});
